module.exports = __webpack_public_path__ + "img/icon-person-profile.03897ed.png";